import { render, staticRenderFns } from "./EmployeeViewEmployeeInfoCard.vue?vue&type=template&id=348b769c"
import script from "./EmployeeViewEmployeeInfoCard.vue?vue&type=script&lang=js"
export * from "./EmployeeViewEmployeeInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports